import { render, staticRenderFns } from "./form-component-selectv2.vue?vue&type=template&id=ad8c7084&scoped=true"
import script from "./form-component-selectv2.vue?vue&type=script&lang=ts"
export * from "./form-component-selectv2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad8c7084",
  null
  
)

export default component.exports